import mixpanel, { Callback } from "mixpanel-browser";
import { useCallback } from "react";
import { getOverviewData as getSubscriptionOverviewData } from "api/subscriptions";
import { Organization } from "types/app";
import { TOverviewData as TSubscriptionOverviewData } from "types/subscription";
import { useQuery } from "react-query";

export const useMixpanel = () => {

    const track = 
      useCallback((event: string,
      props?: Record<string, string | number | boolean | string[] | Date>, callback?: Callback) => {
      const safeProps = Object.fromEntries(
        Object.entries(props || {}).map(([key, value]) => {
          if (Array.isArray(value)) {
            return [key, value.join(", ")];
          }
  
          if (value instanceof Date) {
            return [key, value.toISOString()];
          }
  
          return [key, value];
        })
      ) as Record<string, string | number | boolean>;
  
      if (mixpanel) {
        mixpanel.track(event, safeProps, callback);
      }
    },[])
   
   
  return { track };
};

export const useIntegrationMixpanelEvent = (
  { shouldFetchSubscriptionDetails } = { shouldFetchSubscriptionDetails: true }
) => {
  const { track } = useMixpanel();

  const { data: orgDetails } = useQuery<Organization>(["OrgDetails"]);

  const { data: subscriptionOverviewData } = useQuery<TSubscriptionOverviewData>({
    queryKey: ["subscriptionOverviewInformation"],
    queryFn: getSubscriptionOverviewData,
    enabled: shouldFetchSubscriptionDetails,
  });

  const triggerMixpanelEvent = useCallback(
    (eventName: string, callback?: Callback) => {
      if (subscriptionOverviewData && orgDetails) {
        track(
          eventName,
          {
            "Subscription Plan": subscriptionOverviewData?.plan_subscription?.plan_name,
            "User Role": orgDetails?.user_role,
            Industry: orgDetails?.organization_industry,
            Size: orgDetails?.organization_size,
          },
          callback
        );
      }
    },
    [subscriptionOverviewData, orgDetails, track]
  );

  return { triggerMixpanelEvent };
};
